import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import route from './route'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: route('home'),
      meta: {
        pageTitle: '首页',
        content: '首页'
      }
    },
    {
      path: '/ProductService',
      name: 'ProductService',
      component: route('ProductService'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/WisdomPage',
      name: 'wisdomPage',
      component: route('wisdomPage'),
      meta: {
        pageTitle: '智慧动保',
        content: ''
      }
    },
    {
      path: '/InformationPage',
      name: 'informationPage',
      component: route('informationPage'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/DevelopmentPage',
      name: 'developmentPage',
      component: route('developmentPage'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/InvestorsPage',
      name: 'investorsPage',
      component: route('investorsPage'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/AboutMy',
      name: 'AboutMy',
      component: route('AboutMy'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/wisdom/index',
      name: 'wisdomIndex',
      component: route('wisdom/index'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/wisdom/newsDetail',
      name: 'wisdomDetail',
      component: route('wisdom/newsDetail'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/wisdom/newsList',
      name: 'wisdomNewsList',
      component: route('wisdom/newsList'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/productService/index',
      name: 'productIndex',
      component: route('productService/index'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/productService/details',
      name: 'productdetail',
      component: route('productService/details'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/productService/listDetail',
      name: 'productlistDetail',
      component: route('productService/listDetail'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/information/index',
      name: 'informationIndex',
      component: route('information/index'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/information/newsList',
      name: 'informationList',
      component: route('information/newsList'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/information/proDetail',
      name: 'proDetail',
      component: route('information/proDetail'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/information/resultDetail',
      name: 'resultDetail',
      component: route('information/resultDetail'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/information/newsDetail',
      name: 'newsDetail',
      component: route('information/newsDetail'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/development/index',
      name: 'developmentIndex',
      component: route('development/index'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/development/workDetail',
      name: 'workDetail',
      component: route('development/workDetail'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/development/elegantDetail',
      name: 'elegantDetail',
      component: route('development/elegantDetail'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/aboutUs/index',
      name: 'aboutUsIndex',
      component: route('aboutUs/index'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/aboutUs/aboutList',
      name: 'aboutList',
      component: route('aboutUs/aboutList'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/invest/index',
      name: 'investIndex',
      component: route('invest/index'),
      meta: {
        pageTitle: '',
        content: ''
      }
    },
    {
      path: '/invest/teamDetail',
      name: 'teamDetail',
      component: route('invest/teamDetail'),
      meta: {
        pageTitle: '',
        content: ''
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js